import { styled } from "@mui/material";
import { colors } from "../../../../utils";

export const Container = styled("div")(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: "16px",
}));

export const TokenBundle = styled("div")(({ isSelected }) => ({
  display: 'flex',
  borderRadius: '8px',
  gap: "12px",
  padding: "12px",
  border: isSelected ? "2px solid #8F38EF" : "1px solid #E1E1E1",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: isSelected ? "#9B5AF80D" : "transparent"
}));

export const TokenInformation = styled("div")(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: "4px",
  justifyContent: "center",
}));

export const Tokens = styled("span")(() => ({
  fontWeight: 800,
    fontSize: "26px",
    lineHeight: "28px",
    color: colors.PrimaryPurple,
    marginRight: "4px",
}));

export const PriceContainer = styled("div")(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: "4px",
}));

export const DiscountInfo = styled("div")(() => ({
  display: 'flex',
  gap: "10px",
  borderRadius: "4px",
  padding: "4px",
  backgroundColor: "#2E7D32",
  color: "#FFFFFF",
  fontSize: "10px",
}));

export const TokenPrice = styled("span")(() => ({
  fontSize: "18px",
  lineHeight: "20px",
  color: "#0F0F0F",
  fontWeight: 700,
  fontFamily: 'DM Sans, sans-serif',
}));